import DTO from './DTO';
import DtoType from './converters/DtoType';
import AuthorizedUserDTO from './AuthorizedUserDTO';

class AuthorizedDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'loggedIn',
        type: Boolean,
      },
      {
        name: 'loginProcess',
        type: Boolean,
      },
      {
        name: 'authorizedData',
        type: DtoType(AuthorizedUserDTO),
      },
      {
        name: 'token',
        type: String,
      },
      {
        name: 'loadingForgotPassword',
        type: Boolean,
      },
      {
        name: 'loadingEsiaRedirectUrl',
        type: Boolean,
      },
      {
        name: 'loadingSetCompany',
        type: Boolean,
      },
      {
        name: 'loadingProfileCompanies',
        type: Boolean,
      },
      {
        name: 'profileCompaniesList',
        type: Object,
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      loggedIn: this.loggedIn,
      loginProcess: this.loginProcess,
      authorizedData: this.authorizedData.getData(),
      token: this.token,
      loadingForgotPassword: this.loadingForgotPassword,
      loadingEsiaRedirectUrl: this.loadingEsiaRedirectUrl,
      loadingSetCompany: this.loadingSetCompany,
      loadingProfileCompanies: this.loadingProfileCompanies,
      profileCompaniesList: this.profileCompaniesList,
    };
  }
}

export default AuthorizedDTO;
